import { useCallback } from "react";
import { useDispatch } from "react-redux";

import {
  closeNavigation,
  setNavigationCategoryId,
} from "web/features/app/appSlice";

import type { Submenu } from "./types";

const useHandleListNavigation = ({
  setSubmenu,
}: {
  setSubmenu: (submenu: Submenu) => void;
}) => {
  const dispatch = useDispatch();

  const handleCategoryClick = useCallback(
    (categoryId: number, hasSubcategory: boolean) => {
      if (hasSubcategory) {
        dispatch(setNavigationCategoryId(categoryId));
      } else {
        dispatch(setNavigationCategoryId(null));
        dispatch(closeNavigation());
      }
    },
    [dispatch, setNavigationCategoryId, closeNavigation]
  );

  const handleSubmenuClick = useCallback(
    (title: string, items: Array<{ title: string; url: string }>) => {
      setSubmenu({ title, items });
    },
    []
  );

  const handleNavigate = useCallback(() => {
    dispatch(setNavigationCategoryId(null));
    dispatch(closeNavigation());
  }, [dispatch, setNavigationCategoryId, closeNavigation]);

  const handleBack = useCallback(
    (parentId: number | null) => {
      dispatch(setNavigationCategoryId(parentId));
    },
    [dispatch, setNavigationCategoryId]
  );

  return {
    handleCategoryClick,
    handleSubmenuClick,
    handleNavigate,
    handleBack,
  };
};

export default useHandleListNavigation;
